import LBox from "@components/LBox";
import LIcon, { LIconProps } from "@components/LIcon";
import LText, { Props as TextProps } from "@components/LText";
import { LBoxProps, theme } from "@theme";
import { secondsToTime } from "@utils/index";

type DurationProps = {
  duration: number | undefined;
  boxProps?: LBoxProps;
  iconProps?: Partial<LIconProps>;
  textProps?: Omit<TextProps, "children">;
};

const Duration = ({
  duration,
  boxProps,
  iconProps,
  textProps,
}: DurationProps) => {
  if (!duration) return null;
  return (
    <LBox flexDirection="row" alignItems="center" gap="s1_5" {...boxProps}>
      <LIcon
        colors={{ color: theme.colors.lightGrey }}
        name="clock"
        size={16}
        {...iconProps}
      />
      <LText variant="Body/B1/Medium" color="lightGrey" {...textProps}>
        {secondsToTime(duration)}
      </LText>
    </LBox>
  );
};

export default Duration;
